import { render, staticRenderFns } from "./ShoppingListNewList.vue?vue&type=template&id=37995526&"
import script from "./ShoppingListNewList.vue?vue&type=script&lang=js&"
export * from "./ShoppingListNewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports